export class QuestionType {
  questionTypeId: any;
  name: string;

  constructor() {
    this.questionTypeId = "";
    this.name = "";
  }
}
